import { render, staticRenderFns } from "./TaskForm.vue?vue&type=template&id=6d367da4"
import script from "./TaskForm.vue?vue&type=script&lang=js"
export * from "./TaskForm.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/componenterpserver/gitrepo/unitmodeler/jp-ui/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('6d367da4')) {
      api.createRecord('6d367da4', component.options)
    } else {
      api.reload('6d367da4', component.options)
    }
    module.hot.accept("./TaskForm.vue?vue&type=template&id=6d367da4", function () {
      api.rerender('6d367da4', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/modules/flowable/task/TaskForm.vue"
export default component.exports